import React, { useState, useContext } from "react";
import axios from "axios";
import useEntitesTable from "./useEntitesTable.js";
import FileUpload from "./file-upload.component.jsx";
import UserService from "../../services/UserService";
import Button from "@mui/material/Button";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import {postFileUpload} from "services/ConfigServices"
import { NotificationManager } from 'react-notifications';

function UploadDialog(props) {
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const { closeModal, refetch } = props;

  const [newDocumentsInfo, setNewDocumentsInfo] = useState({
    documents: [],
  });

  const updateUploadedFiles = (files) =>
    setNewDocumentsInfo({ ...newDocumentsInfo, documents: files });

  const handleSubmit = async (event) => {
    event.preventDefault();

    //J'ai combien de fichiers?
    let size = newDocumentsInfo.documents.length;
    console.log(size);
    let sent = 0;
    let errors = 0;
    for (const [index, value] of newDocumentsInfo.documents.entries()) {
      const formData = new FormData();
      // we append each element to the form
      formData.append("files[]", newDocumentsInfo.documents[index]);

      axios
        .post(
          postFileUpload(chartIdGroup,"GED"),
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {
          sent = sent + 1;
          if (sent  == size) {
            NotificationManager.success("Documents ajoutés");
            closeModal();
            refetch();
          }
          else if (sent + errors == size) {
            NotificationManager.error("Certains documents n'ont pas pu être envoyés");
            closeModal();
            refetch();
          } else {

          }
          //Si nombre de réponse reçues = nombre de fichiers
        })
        .catch((err) => {
          errors++;
          if (errors  == size) {
            NotificationManager.error("Une erreur est survenue");
            closeModal();
            refetch();
          }
          if (sent + errors == size) {
            NotificationManager.error("Certains documents n'ont pas pu être envoyés");
            closeModal();
            refetch();
          } else {
           
          }
        });
    }
  };


  return (
    <div style={{ minWidth: "400px" }}>
      <form>
        <FileUpload
          accept=""
          //accept=".jpg,.png,.jpeg,.pdf,.csv"
          label="Documents"
          multiple
          updateFilesCb={updateUploadedFiles}
        />
        <Button
          style={{
            color: "#FFFFFF",
            backgroundColor: "#91C73C",
            fontWeight: "normal",
            fontWeight: "bold",
            height: "40px",
            fontSize: "0.75rem",
            padding: "5px 15px",
            marginRight: "0px",
            marginBottom: "0px",
            marginTop: "15px",
            fontFamily: '"Source Sans Pro",sans-serif',
            width: "96%",
            marginLeft: "2%",
          }}
          onClick={handleSubmit}
        >
          Importer
        </Button>
      </form>
    </div>
  );
}

export default UploadDialog;
